import axios from "axios";

export function getWorkOrderCategories(filters: any = null) {
  let requestData
  if (typeof filters !== 'undefined') {
    requestData = {
      params: filters
    }
  }
  return axios.get('/work-order-categories', requestData)
}

export function getWorkOrderCategory(id: number|string) {
  return axios.get('/work-order-categories/' + id)
}

export function updateWorkOrderCategory(id: number|string, data: any) {
  return axios.put('/work-order-categories/' + id, data)
}
